'use strict';

exports.__esModule = true;
exports.default = EmbeddedVideo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmbeddedVideo(props) {
  var className = props.className,
      href = props.href,
      width = props.width,
      showText = props.showText,
      allowFullScreen = props.allowFullScreen,
      autoPlay = props.autoPlay,
      showCaptions = props.showCaptions,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-video',
        'data-href': href,
        'data-width': width,
        'data-show-text': showText,
        'data-show-captions': showCaptions,
        'data-autoplay': autoPlay,
        'data-allowfullscreen': allowFullScreen
      },
      children
    )
  );
}

EmbeddedVideo.defaultProps = {
  width: undefined,
  showText: undefined,
  allowFullScreen: undefined,
  autoPlay: undefined,
  showCaptions: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=EmbeddedVideo.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/EmbeddedVideo.js
// module id = 1008
// module chunks = 198517197184460